/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：496
 */

module.exports = {
  container: "WatchItem_container__3lYOL",
  itemBox: "WatchItem_itemBox__35r6o",
  closeAction: "WatchItem_closeAction__2f2Cu",
  resetAction: "WatchItem_resetAction__9v4bP",
  name: "WatchItem_name__2NMzt",
  screenIcon: "WatchItem_screenIcon__3vwhh",
  nameText: "WatchItem_nameText__2OTIm",
  value: "WatchItem_value__N7CCK",
  valueText: "WatchItem_valueText__rIubh",
  action: "WatchItem_action__3HODB",
  foldAction: "WatchItem_foldAction__pdWxW",
  unFoldAction: "WatchItem_unFoldAction__3yVkr"
}
